module.exports = __webpack_public_path__ + "static/media/cancelarPoliza.1496f2cf.svg";